import { render, staticRenderFns } from "./RetirarPlacaDialog.vue?vue&type=template&id=66790308&"
import script from "./RetirarPlacaDialog.vue?vue&type=script&lang=js&"
export * from "./RetirarPlacaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports